import Vue from 'vue'
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)

export declare interface IVueCookies {
  config(expireTimes: any, path?: string): void // default: expireTimes = 1d , path=/
  set(keyName: string, value: any, expireTimes?: any, path?: string, domain?: string, secure?: boolean): IVueCookies
  get(keyName: string): any
  remove(keyName: string, path?: string, domain?: string): IVueCookies
  isKey(keyName: string): boolean
  keys(): Array<any>
}
